import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core'
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner'
import { TranslatePipe } from '@ngx-translate/core'

const startShowSpinnerDelay = 250

@Component({
  selector: 'app-busy-spinner',
  templateUrl: './busy-spinner.component.html',
  styleUrls: ['./busy-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, NgxSpinnerComponent],
})
export class BusySpinnerComponent {
  private readonly spinner = inject(NgxSpinnerService)

  messageKey = ''
  private startShowSpinnerTimeout: number | undefined = undefined

  private _startShowSpinnerDelay = startShowSpinnerDelay

  @Input() set startDelay(value: number) {
    if (value >= 0) {
      this._startShowSpinnerDelay = value
    }
  }

  @Input() set busyKey(key: string) {
    if (key) {
      this.startSpinner(key)
    } else {
      this.stopSpinner()
    }
  }

  private startSpinner(key: string) {
    this.messageKey = key
    this.showSpinner(true)
  }

  private stopSpinner() {
    this.showSpinner(false)
  }

  private showSpinner = (state: boolean): void => {
    if (state) {
      if (!this.startShowSpinnerTimeout) {
        // @ts-ignore
        this.startShowSpinnerTimeout = setTimeout(() => {
          this.spinner.show()
        }, this._startShowSpinnerDelay)
      }
    } else {
      if (this.startShowSpinnerTimeout) {
        clearTimeout(this.startShowSpinnerTimeout)
        this.startShowSpinnerTimeout = undefined
      }
      this.spinner.hide()
      this.messageKey = ''
    }
  }
}
